"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/ShareHeart` instead */
export const ShareHeart = createSVGIcon(
  <>
    <path
      d="M15 14.572 8.143 8.229C4.406 4.474 9.857-2.794 15 3.086c5.143-5.863 10.646 1.406 6.857 5.143zM.857 18.857l4.19 3.49a3.43 3.43 0 0 0 2.194.796h11.045c.789 0 1.428-.64 1.428-1.428a2.86 2.86 0 0 0-2.858-2.858H9.178"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m6 17.143 1.285 1.286a1.818 1.818 0 1 0 2.572-2.572l-1.995-1.995a3.43 3.43 0 0 0-2.424-1.005H.856"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "ShareHeart",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
